import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ManualSelect } from 'autogen/translation-keys/trans-website-paging';
import type { IOption } from 'components/shared/inputs/select';
import Select from 'components/shared/inputs/select/Select';
import { breakpoint, sizes } from 'variables';
import PagingInput from './PagingInput';

const StyledSelect = styled(Select)`
    width: 80px;
    ${breakpoint.up(sizes.sm)} {
        width: auto;
    }
`;

export default function PagingSelect({
    currentPageNumber,
    pages,
    onChange,
    numberOfPages
}: {
    currentPageNumber: number;
    pages: number[];
    onChange: (page: number) => void;
    numberOfPages: number;
}) {
    const { t } = useTranslation();
    const [shouldDisplayPagingInput, setShouldDisplayPagingInput] = useState(false);
    const displayPagingInputValue = 'pagingInput';

    const options: IOption[] = [
        ...pages.map((page) => ({
            label: page.toString(),
            value: page.toString()
        })),
        { label: t(ManualSelect), value: displayPagingInputValue }
    ];

    const selectedOption = options.find((option) => Number(option.value) === currentPageNumber);

    const handlePageChangeOrDisplayPagingInput = (option: IOption) => {
        if (option.value === displayPagingInputValue) {
            setShouldDisplayPagingInput(true);
        } else {
            onChange(Number(option.value));
        }
    };

    if (shouldDisplayPagingInput) {
        return <PagingInput numberOfPages={numberOfPages} currentPageNumber={currentPageNumber} onBlur={onChange} />;
    }

    return (
        <StyledSelect
            ariaLabel="pagination select"
            size="lg"
            options={options}
            value={selectedOption}
            onChange={handlePageChangeOrDisplayPagingInput}
        />
    );
}
